import { useSelector } from 'react-redux';
import { useEffectOnce } from 'react-use';

import { IState } from 'models/reducers/i-state.interface';
import { ITradeAsset } from 'models/trade/i-trade-details.interface';

import MarketVenueCardMain from 'routes/market/marketVenueCard/marketVenueCardMain/MarketVenueCardMain';

import ElementLoader from 'components/element-loader/ElementLoader';
import NftCardWrapper from 'components/nftCard/nftCardWrapper/NftCardWrapper';

import { INftParams } from 'hooks/events/useEventsParams';
import { useNftCardExpectedAnnualYield } from 'hooks/shared/useNftCardExpectedAnnualYield';
import { useTraits } from 'hooks/useTraits';

import { IDailyDealsProps } from '../dailyDealsSection/DailyDealsSection';

interface IDailyDealsNftCardMain {
  asset: ITradeAsset;
}

const DailyDealsNftCardMain = ({ asset }: IDailyDealsNftCardMain) => {
  const { id, category } = useTraits(asset.traits);

  return (
    <MarketVenueCardMain
      id={+id}
      address={asset.address}
      availableShares={asset.total_shares}
      cardUrl={asset.image_original_url || ''}
      cardAnimationUrl={asset.animation_url || ''}
      category={category}
      name={asset.name || '-'}
      iconUrl={asset.marker_url}
    />
  );
};

const DailyDealsNftCardMainAnnualYield = ({ nftId }: INftParams) => {
  const { expectedAnnualYield, loadingExpectedAnnualYield, onFetchExpectedAnnualYield } =
    useNftCardExpectedAnnualYield(nftId);

  useEffectOnce(() => {
    onFetchExpectedAnnualYield();
  });

  return (
    <ElementLoader loading={loadingExpectedAnnualYield}>
      <div className="tw-mt-3 tw-flex tw-justify-between tw-gap-1 tw-rounded-lg tw-bg-cardBackground tw-px-2 tw-py-[5px]">
        <p className="tw-text-menuLinkColor">Estimated Annual Yield</p>
        <p>{expectedAnnualYield || '-'}</p>
      </div>
    </ElementLoader>
  );
};

const DailyDealsNftCard = ({ deal }: IDailyDealsProps) => {
  const { dealsAssets } = useSelector((state: IState) => state.dailyDeals);
  const dealAsset = dealsAssets.find((asset) => asset.id === deal?.asset.id);

  return (
    <NftCardWrapper twClassName="tw-min-w-[280px] lg:tw-min-w-[280px]">
      {dealAsset && (
        <>
          <DailyDealsNftCardMain asset={dealAsset} />
          <DailyDealsNftCardMainAnnualYield nftId={dealAsset.token_id} />
        </>
      )}
    </NftCardWrapper>
  );
};

export default DailyDealsNftCard;
